import React from "react";
import { connect } from "react-redux";
import autoBind from "auto-bind";

import classNames from "@js/helpers/class_names.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

import { ceDuplicateContent } from "@js/actions/studio/campaign_content_section/generate_content.js";
import { ceMakeMultipart } from "@js/actions/studio/campaign_content_section/multi_part_contents.js";
import { ceModalAttemptDownloadContent } from "@js/actions/studio/campaign_content_section/modal_download_content.js";
import { ceModalChangeHtmlEditorOpen } from "@js/actions/studio/campaign_content_section/modal_change_html_editor.js";
import { ceModalEditNameOpen } from "@js/actions/studio/campaign_content_section/modal_edit_name.js";
import { ceModalEditSubjectOpen } from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";
import { ceModalUploadFromFileOpen } from "@js/actions/studio/campaign_content_section/modal_upload_from_file.js";
import { ceModalUploadFromUrlOpen } from "@js/actions/studio/campaign_content_section/modal_upload_from_url.js";
import { ceRemoveContentOpen } from "@js/actions/studio/campaign_content_section/remove_content.js";
import { ceScreenEditorOpen } from "@js/actions/studio/campaign_content_section/screen_editor.js";
import { ceScreenViewRenderedPreviewOpen } from "@js/actions/studio/campaign_content_section/screen_view_rendered_preview.js";
import { ceScreenViewTextVersionOpen } from "@js/actions/studio/campaign_content_section/screen_view_text_version.js";
import { ceScreenViewWebVersionOpen } from "@js/actions/studio/campaign_content_section/screen_view_web_version.js";

class StudioCampaignContentDropdownMenu extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      dropdown: false,
    };
  }

  componentDidMount() {
    document.body.addEventListener("click", this._globalHideDropdown);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this._globalHideDropdown);
  }

  _handleMenuClick(fn) {
    return (e) => {
      this._hideDropdown();

      e.preventDefault();
      e.stopPropagation();

      fn();
    };
  }

  _handleDisabledMenuClick() {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  _hideDropdown(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ dropdown: false });
  }

  _toggleDropdown() {
    this.setState({ dropdown: !this.state.dropdown });
  }

  _globalHideDropdown(e) {
    if (
      !this._rootNode ||
      !this._rootNode.contains(e.target)
    ) {
      this._hideDropdown();
    }
  }

  render() {
    let content = this.props.content;
    let editingUnavailable = !this.props.allow_editing;

    var singleDropdownEntry = (
      text,
      fn,
      secondaryText,
      secondaryFn,
      unavailable,
    ) => {
      let className = classNames({
        "tt-line": true,
        "tt-line-unavailable": !!unavailable,
      });

      let clickHandler = unavailable
        ? this._handleDisabledMenuClick
        : this._handleMenuClick;

      return (
        <div className={className} onClick={clickHandler(fn)}>
          <a href="#">{text}</a>
          {secondaryText && secondaryFn && (
            <span>
              &nbsp;/&nbsp;
              <a href="#" onClick={clickHandler(secondaryFn)}>
                {secondaryText}
              </a>
            </span>
          )}
        </div>
      );
    };

    let singleDropdownEntryAction = (label, action, unavailable) => {
      if (!action) return null;
      return singleDropdownEntry(
        label,
        () => this.props.dispatch(action),
        null,
        null,
        unavailable,
      );
    };
    return (
      <div
        ref={(n) => { this._rootNode = n; }}
        className={classNames({
          "campaign-content-section-entry-dropdown": true,
        })}
      >
        <a
          className="action-dropdown-btn"
          href="#"
          onClick={this._handleMenuClick(this._toggleDropdown)}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </a>
        {this.state.dropdown && (
          <div className="tt-dropdown" onClick={this.props.hideDropdown}>
            <div className="tt-tooltip">
              <div className="tt-bottom">
                <div>
                  {singleDropdownEntryAction(
                    t(`phrases.react_content.action_dropdown.edit_name`),
                    ceModalEditNameOpen(content.client_content_id),
                    editingUnavailable,
                  )}
                  {singleDropdownEntryAction(
                    t(`phrases.react_content.action_dropdown.edit_subject`),
                    ceModalEditSubjectOpen(content.client_content_id),
                    editingUnavailable,
                  )}
                  {this.props.content.format !== "text" &&
                    singleDropdownEntryAction(
                      t(
                        `content_editor.edit_html_in.${
                          content.active_html_editor
                        }`,
                      ),
                      ceScreenEditorOpen(content.client_content_id, "html"),
                      editingUnavailable,
                    )}
                  {content.format === "text" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.add_html_part`),
                      ceMakeMultipart(this.props.content.client_content_id),
                      editingUnavailable,
                    )}
                  {this.props.content.format !== "html" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.edit_text_part`),
                      ceScreenEditorOpen(content.client_content_id, "text"),
                      editingUnavailable,
                    )}
                  {content.format === "html" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.add_text_part`),
                      ceMakeMultipart(this.props.content.client_content_id),
                      editingUnavailable,
                    )}

                  <hr />

                  {content.format !== "text" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.change_editor`),
                      ceModalChangeHtmlEditorOpen(content.client_content_id),
                      editingUnavailable,
                    )}
                  {singleDropdownEntryAction(
                    t(`phrases.react_content.action_dropdown.import_from_url`),
                    ceModalUploadFromUrlOpen(content.client_content_id),
                    editingUnavailable,
                  )}
                  {singleDropdownEntryAction(
                    t(`phrases.react_content.action_dropdown.import_from_file`),
                    ceModalUploadFromFileOpen(content.client_content_id),
                    editingUnavailable,
                  )}
                  {singleDropdownEntryAction(
                    t(
                      `phrases.react_content.action_dropdown.duplicate_content`,
                    ),
                    ceDuplicateContent(content.client_content_id),
                    editingUnavailable,
                  )}

                  <hr />

                  {content.format === "both" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.remove_text`),
                      ceRemoveContentOpen(content.client_content_id, "text"),
                      editingUnavailable,
                    )}
                  {content.format === "both" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.remove_html`),
                      ceRemoveContentOpen(content.client_content_id, "html"),
                      editingUnavailable,
                    )}

                  {singleDropdownEntryAction(
                    this.props.isOnlyContent
                      ? t(`phrases.react_content.action_dropdown.clear_content`)
                      : t(
                          `phrases.react_content.action_dropdown.remove_content`,
                        ),
                    ceRemoveContentOpen(content.client_content_id, "whole"),
                    editingUnavailable,
                  )}

                  <hr />

                  {content.format !== "text" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.view_web`),
                      ceScreenViewWebVersionOpen(content.client_content_id),
                      !content.html,
                    )}
                  {content.format !== "html" &&
                    singleDropdownEntryAction(
                      t(`phrases.react_content.action_dropdown.view_text`),
                      ceScreenViewTextVersionOpen(content.client_content_id),
                    )}
                  {singleDropdownEntryAction(
                    t(`phrases.react_content.action_dropdown.view_rendered`),
                    ceScreenViewRenderedPreviewOpen(content.client_content_id),
                    !content.preview_image.image_url, // Make this unavailable if no url set
                  )}
                  {singleDropdownEntry(
                    content.format === "text"
                      ? t(`phrases.react_content.action_dropdown.download_text`)
                      : t(
                          `phrases.react_content.action_dropdown.download_html`,
                        ),
                    content.format === "text"
                      ? () => {
                          this.props.dispatch(
                            ceModalAttemptDownloadContent(
                              content.client_content_id,
                              "text",
                            ),
                          );
                        }
                      : () => {
                          this.props.dispatch(
                            ceModalAttemptDownloadContent(
                              content.client_content_id,
                              "html",
                            ),
                          );
                        },
                    content.format === "both" &&
                      t("custom_fields.field_types.text"),
                    content.format === "both" &&
                      (() => {
                        this.props.dispatch(
                          ceModalAttemptDownloadContent(
                            content.client_content_id,
                            "text",
                          ),
                        );
                      }),
                  )}
                </div>
                <i />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect()(StudioCampaignContentDropdownMenu);
